// extracted by mini-css-extract-plugin
module.exports = {"dialogContact":"DialogContact_dialogContact_3M6yg"};